import { get, post, put, patch } from '@/utils/request'
export const getOperation = data => {
  return post('/operate/getOperateLogPage', data, 'json')
}
export const getOperateLogDetail = data => {
  return post('/operate/getOperateLogDetail', data, 'json')
}